<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>營運資料中心</b-breadcrumb-item>
            <b-breadcrumb-item active>訂單資料查詢與匯出</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <b-overlay :show="showLoading" rounded="sm">
        <h4>訂單資料查詢與匯出</h4>

        <div class="row mx-0 justify-content-between mb-2 mt-3">
          <div>
            <b-button v-b-toggle.collapse-filter variant="outline-info" class="mr-2">
              <span class="mdi mdi-filter"></span>篩選條件
            </b-button>
          </div>
          <div>
            <b-dropdown text="匯出" variant="primary" class="mr-2">
              <b-dropdown-item @click="listExport">清單匯出</b-dropdown-item>
              <b-dropdown-item @click="detailExport">明細匯出</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

        <b-collapse id="collapse-filter" class="mt-2">
          <div class="border p-2 small">
            <b-form>
              <div class="d-flex flex-column flex-xl-row flex-wrap">
                <!-- 通路名稱 -->
                <b-form-group
                  label="通路名稱"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-select
                    class="mr-3"
                    v-model="query.merchant_id"
                    :options="merchants"
                    :disabled="merchants.length == 2 || showLoading"
                  ></b-form-select>
                </b-form-group>

                <!-- 下單時間 -->
                <b-form-group
                  label="下單時間"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <DateSearchPicker
                    class="mr-md-2 mr-0"
                    v-model="orderDateBetween"
                    startedPlaceholder="開始時間"
                    endedPlaceholder="結束時間"
                    size="sm"
                    :disabled="showLoading"
                    @input="handleDateChange"
                  />
                </b-form-group>

                <!-- 單筆訂單金額 -->
                <b-form-group
                  label="單筆訂單金額"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <div class="d-flex align-items-center">
                    <b-form-input
                      v-model.number="query.total_min"
                      type="number"
                      placeholder="最低金額"
                      class="mr-2"
                      style="width: 120px;"
                      size="sm"
                      :disabled="showLoading"
                    ></b-form-input>
                    <span class="mx-1">～</span>
                    <b-form-input
                      v-model.number="query.total_max"
                      type="number"
                      placeholder="最高金額"
                      class="ml-2"
                      style="width: 120px;"
                      size="sm"
                      :disabled="showLoading"
                    ></b-form-input>
                    <span class="ml-2">元</span>
                  </div>
                </b-form-group>

                <!-- 商品標題 -->
                <b-form-group
                  label="商品標題/規格名稱"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-input
                    class="mr-3"
                    v-model="query.item_name"
                    placeholder="搜尋 商品標題/規格名稱"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-input>
                </b-form-group>

                <!-- 商品代號 -->
                <b-form-group
                  label="商品規格代碼/序號"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-input
                    class="mr-3"
                    v-model="query.item_code"
                    placeholder="搜尋 訂單明細編號/規格代碼/規格序號"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-input>
                </b-form-group>

                <!-- 是否有使用點數 -->
                <b-form-group
                  label="是否有使用點數"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-select
                    class="mr-3"
                    v-model="query.has_used_reward_points"
                    :options="triStateOptions"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-select>
                </b-form-group>

                <!-- 是否入點 -->
                <b-form-group
                  label="是否入點"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-select
                    class="mr-3"
                    v-model="query.points_entry"
                    :options="pointsEntryOptions"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-select>
                </b-form-group>

                <!-- 是否有會員 -->
                <b-form-group
                  label="是否有會員"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-select
                    class="mr-3"
                    v-model="query.has_customer"
                    :options="triStateOptions"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-select>
                </b-form-group>

                <!-- 訂單狀態 -->
                <b-form-group
                  label="訂單狀態"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-input
                    class="mr-3"
                    v-model="query.status"
                    placeholder="完全比對"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-input>
                </b-form-group>

                <!-- 出貨狀態 -->
                <b-form-group
                  label="出貨狀態"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-input
                    class="mr-3"
                    v-model="query.delivery_status"
                    placeholder="完全比對"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-input>
                </b-form-group>

                <!-- 付款狀態 -->
                <b-form-group
                  label="付款狀態"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-input
                    class="mr-3"
                    v-model="query.payment_status"
                    placeholder="完全比對"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-input>
                </b-form-group>

                <!-- 退貨狀態 -->
                <b-form-group
                  label="退貨狀態"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-input
                    class="mr-3"
                    v-model="query.return_status"
                    placeholder="完全比對"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="flex-column">
                <b-button
                  variant="primary"
                  class="mb-2 mb-xl-0 mr-2"
                  @click="resetSearch"
                  ><i class="mdi mdi-restart"></i> 重置搜尋條件</b-button
                >
                <b-button
                  variant="primary"
                  class="mb-2 mb-xl-0"
                  @click="handleSearch"
                  ><i class="fa fa-search"></i> 搜尋
                </b-button>
              </div>
            </b-form>
          </div>
        </b-collapse>



        <b-table
          responsive
          striped
          hover
          :items="orders"
          :fields="dynamicFields"
          @sort-changed="handleSort"
        >
          <template #cell(order_number)="data">
            <router-link
              :to="{
                name: 'OrderDetail',
                params: {
                  order_id: data.item.id,
                },
              }"
            >
              {{ data.item.order_number }}
            </router-link>
          </template>
          <template #cell(memo)="data">
            <div class="d-flex flex-column align-items-center">
              <span
                v-if="data.item.memo"
                v-b-modal.modal-memo-view
                class="mdi mdi-tag-text-outline mr-1"
                style="cursor: pointer; font-size: 1rem;"
                :id="`popover-memo-${data.item.id}`"
                @click="modalTitle = '消費備註', modalContent = data.item.memo"
              ></span>
              <b-popover
                v-if="data.item.memo"
                :target="`popover-memo-${data.item.id}`"
                triggers="hover focus"
              >
                <div class="text-left">點擊，觀看『消費備註』</div>
              </b-popover>

              <span
                v-if="data.item.processed_memo"
                v-b-modal.modal-memo-view
                class="mdi mdi-coin"
                style="cursor: pointer; font-size: 1rem;"
                :id="`popover-points-${data.item.id}`"
                @click="modalTitle = '入點說明', modalContent = data.item.processed_memo"
              ></span>
              <b-popover
                v-if="data.item.processed_memo"
                :target="`popover-points-${data.item.id}`"
                triggers="hover focus"
              >
                <div class="text-left">點擊，觀看『入點說明』</div>
              </b-popover>
            </div>
          </template>
          <template #cell(action)="data">
            <b-button
              class="ml-2"
              variant="inverse-primary"
              :to="{
                name: 'OrderDetail',
                params: {
                  order_id: data.item.id,
                },
              }"
              ><span class="mdi mdi-eye mr-1"></span>查看
            </b-button>
          </template>
        </b-table>
        <CustomPagination
          :currentPage="query.page"
          :totalRows="totalRows"
          :perPage="query.per_page"
          @page-change="handlePageChange"
          @per-page-change="handlePerPageChange"
        />

        <!-- Memo View Modal -->
        <b-modal id="modal-memo-view" :title="modalTitle">
          <div class="p-3" style="white-space: pre-wrap; max-height: 400px; overflow-y: auto;">{{ modalContent }}</div>
          <template #modal-footer="{ cancel }">
            <b-button
              variant="outline-danger"
              size="sm"
              class="float-right"
              @click="cancel()"
            >
              關閉
            </b-button>
          </template>
        </b-modal>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { format } from "date-fns";
import orderApi from "@/apis/order";
import merchantApi from "@/apis/merchant";
import * as consts from "@/consts";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import DateSearchPicker from "@/components/Page/Dashboard/DateSearchPicker.vue";
import { updateQueryFromRoute, updateUrl } from "@/utils/updateUrl";
import { paginationMixin } from "@/mixins/pagination";

export default {
  name: "OrderSearchExport",
  mixins: [paginationMixin],
  components: { CustomPagination, DateSearchPicker },
  data() {
    return {
      consts,
      showLoading: false,
      merchants: [{ value: null, text: "全部" }],
      totalRows: 0,
      // 顧客姓名欄位（動態會員欄位將插入這之後）
      customerNameField: [
        {
          key: "customer.name",
          label: "會員姓名",
          tdClass: 'text-truncate-hover',
        },
      ],
      // 訂單基本欄位（在動態會員欄位之後）
      baseFields: [
        {
          key: "order_number",
          label: "訂單編號",
          sortable: true,
        },
        {
          key: "outer_order_number",
          label: "外部編號",
          sortable: true,
          tdClass: 'text-truncate-hover',
          formatter: (value) => value || '-',
        },
      ],
      // 訂單後半段欄位（會員欄位插入在 baseFields 與 orderFields 之間）
      orderFields: [
        {
          key: "total",
          label: "總價(含稅)",
          formatter: (value) => (value !== null && value !== undefined) ? value : '-',
        },
        {
          key: "reward_points_earned",
          label: "是否入點",
          formatter: (value) => {
            if (value === null || value === undefined) return "未入點處理";
            const n = Number(value);
            if (Number.isNaN(n)) return "-";
            if (n > 0) return "已處理入點";
            if (n === 0) return "無需入點";
            return "退貨扣點";
          },
        },
        {
          key: "memo",
          label: "其他說明",
          thStyle: { width: "1%", whiteSpace: "nowrap" },
        },
        {
          key: "order_at",
          label: "下單時間",
          sortable: true,
          formatter: (value) => {
            if (value) {
              return format(new Date(value), "yyyy-MM-dd HH:mm");
            }
            return "-";
          },
        },
        {
          key: "status_at",
          label: "最新狀態時間",
          sortable: true,
          formatter: (value) => {
            if (value) {
              return format(new Date(value), "yyyy-MM-dd HH:mm");
            }
            return "-";
          },
        },
        {
          key: "action",
          label: "管理",
        },
        {
          key: "merchant_name",
          label: "通路名稱",
        }
      ],
      searchedMerchant: {},
      orders: [],
      initialized: false,
      orderDateBetween: {
        start_at: null,
        end_at: null,
      },
      query: {
        page: 1,
        per_page: 10,
        sort_by: "order_at",
        order_by: "desc",
        merchant_id: null,
        order_at_from: null,
        order_at_to: null,
        total_min: null,
        total_max: null,
        item_name: "",
        item_code: "",
        has_used_reward_points: null,
        points_entry: null,
        has_customer: null,
        status: "",
        delivery_status: "",
        payment_status: "",
        return_status: "",
      },
      modalTitle: null,
      modalContent: null,
      exportDetail: false,
      triStateOptions: [
        { value: null, text: "全部" },
        { value: "1", text: "是" },
        { value: "0", text: "否" },
      ],
      pointsEntryOptions: [
        { value: null, text: "全部" },
        { value: "pending", text: "未入點處理" },
        { value: "credited", text: "已處理入點" },
        { value: "zero", text: "無需入點" },
        { value: "deducted", text: "退貨扣點" },
      ],
    };
  },
  computed: {
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    ...mapState("general", {
      organization: (state) => state.organization,
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
    // 動態計算要顯示的欄位
    // 順序：顧客姓名 → 動態會員欄位 → 訂單基本欄位 → 訂單後段欄位
    dynamicFields() {
      return this.customerNameField
        .concat(this.normalizeProfileFields())
        .concat(this.baseFields)
        .concat(this.orderFields);
    },
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrl(this.query, this.$store, this.$router);
      },
    },
    $route(to) {
      if (!this.initialized) return;
      this.query = { ...to.query };
      this.fetchOrders();
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
  },
  async mounted() {
    await this.$store.dispatch("dashboardModule/fetchModule", {
      org_id: this.organization.id,
      code: "customer",
    });
    this.fetchMerchants();
    this.initialized = true;
  },
  methods: {
    async fetchOrders() {
      this.showLoading = true;

      // 搜尋時更新 searchedMerchant，用於動態欄位計算
      this.searchedMerchant = this.merchants.find(m => m.value === this.query.merchant_id) || {};

      try {
        const params = { ...this.query };

        // 標記為 order_search 頁面
        params.order_search = true;

        // 搜尋前將 字串null(全部) 轉為真正的null
        if (typeof params.merchant_id !== 'undefined' && params.merchant_id === 'null') {
          params.merchant_id = null;
        }

        // 移除空值的參數
        if (!params.order_at_from) delete params.order_at_from;
        if (!params.order_at_to) delete params.order_at_to;
        if (!params.total_min) delete params.total_min;
        if (!params.total_max) delete params.total_max;
        if (!params.item_name) delete params.item_name;
        if (!params.item_code) delete params.item_code;
        if (
          params.has_used_reward_points === null ||
          params.has_used_reward_points === undefined ||
          params.has_used_reward_points === ""
        ) {
          delete params.has_used_reward_points;
        }
        if (
          params.points_entry === null ||
          params.points_entry === undefined ||
          params.points_entry === ""
        ) {
          delete params.points_entry;
        }
        if (
          params.has_customer === null ||
          params.has_customer === undefined ||
          params.has_customer === ""
        ) {
          delete params.has_customer;
        }
        if (!params.status) delete params.status;
        if (!params.delivery_status) delete params.delivery_status;
        if (!params.payment_status) delete params.payment_status;
        if (!params.return_status) delete params.return_status;

        const { data } = await orderApi.getOrders(params);

        this.orders = data.data;
        this.totalRows = data.meta.total;
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "取得訂單資料錯誤", "error");
      }
      this.showLoading = false;
    },
    async handleMerchantIdChange() {
      // 暫時關閉 watcher，避免 updateUrl 被呼叫導致路由更新（父組件重整）
      const prevInitialized = this.initialized;
      this.initialized = false;

      try {
        this.query.page = 1;
        this.handlePageResetWithoutReload();
        await this.fetchOrders();
      } finally {
        // 恢復 initialized，但不強制觸發 updateUrl（避免父層被重整）
        this.initialized = prevInitialized;
      }
    },
    async fetchMerchants() {
      const { data } = await merchantApi.list();

      this.merchants = [
        { value: "null", text: "全部" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: `${merchant.name} (${merchant.type_name})`,
            type: merchant.type
          };
        }),
      ];

      if (!this.query.merchant_id) {
        const merchants = data.data;
        let defaultMerchant =
          merchants.find(
            (merchant) => merchant.type === this.defaultMerchantType
          ) ?? merchants.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE);

        if (defaultMerchant) {
          this.query.merchant_id = defaultMerchant.id;
        }
      }

      if (this.query.merchant_id) {
        const hasMerchant = this.merchants.find(
          (item) => item.value === this.query.merchant_id
        );
        if (!hasMerchant) {
          this.$swal.fire({
            icon: "warning",
            title: "查無此通路",
            confirmButtonText: "確定",
            confirmButtonColor: "#d33",
            reverseButtons: true,
          });
          return;
        }
      }

      // 若已有選中的 merchant_id，同步設定 searchedMerchant 物件
      if (this.query.merchant_id && !this.searchedMerchant.value) {
        this.searchedMerchant = this.merchants.find(m => m.value === this.query.merchant_id) || {};
      }

      await this.fetchOrders();
    },
    handleDateChange(event) {
      // 將 DateSearchPicker 的值同步到 query
      if (event.start_at) {
        this.query.order_at_from = format(new Date(event.start_at), "yyyy-MM-dd");
      } else {
        this.query.order_at_from = null;
      }
      if (event.end_at) {
        this.query.order_at_to = format(new Date(event.end_at), "yyyy-MM-dd");
      } else {
        this.query.order_at_to = null;
      }
    },
    resetSearch() {
      this.orderDateBetween = {
        start_at: null,
        end_at: null,
      };

      // 當只有一間通路時，固定選取該通路
      const defaultMerchantId = this.merchants.length === 2
        ? this.merchants[1].value
        : null;

      this.query = {
        page: 1,
        per_page: 10,
        sort_by: "order_at",
        order_by: "desc",
        merchant_id: defaultMerchantId,
        order_at_from: null,
        order_at_to: null,
        total_min: null,
        total_max: null,
        item_name: "",
        item_code: "",
        has_used_reward_points: null,
        points_entry: null,
        has_customer: null,
        status: "",
        delivery_status: "",
        payment_status: "",
        return_status: "",
      };
      this.fetchOrders();
    },
    handleSearch() {
      this.query.page = 1;
      this.fetchOrders();
    },
    handleSort(ctx) {
      this.query.sort_by = ctx.sortBy;
      this.query.order_by = ctx.sortDesc ? "desc" : "asc";
      this.handlePageReset();
    },
    handlePageChange(newPage) {
      this.query.page = newPage;
    },
    handlePerPageChange(newPerPage) {
      this.query.per_page = newPerPage;
      this.query.page = 1;
    },
    listExport() {
      this.exportDetail = false;
      this.handleExport();
    },
    detailExport() {
      this.exportDetail = true;
      this.handleExport();
    },
    async handleExport() {
      try {
        this.showLoading = true;

        const params = {
          order_search: true,
          export_detail: this.exportDetail,
          merchant_id: this.query.merchant_id !== 'null' ? this.query.merchant_id : null,
          sort_by: this.query.sort_by,
          order_by: this.query.order_by,
        };

        // 有值才傳送
        if (this.query.order_at_from) params.order_at_from = this.query.order_at_from;
        if (this.query.order_at_to) params.order_at_to = this.query.order_at_to;
        if (this.query.total_min) params.total_min = this.query.total_min;
        if (this.query.total_max) params.total_max = this.query.total_max;
        if (this.query.item_name) params.item_name = this.query.item_name;
        if (this.query.item_code) params.item_code = this.query.item_code;
        if (this.query.has_used_reward_points === "0" || this.query.has_used_reward_points === "1") {
          params.has_used_reward_points = this.query.has_used_reward_points;
        }
        if (this.query.points_entry) {
          params.points_entry = this.query.points_entry;
        }
        if (this.query.has_customer === "0" || this.query.has_customer === "1") {
          params.has_customer = this.query.has_customer;
        }
        if (this.query.status) params.status = this.query.status;
        if (this.query.delivery_status) params.delivery_status = this.query.delivery_status;
        if (this.query.payment_status) params.payment_status = this.query.payment_status;
        if (this.query.return_status) params.return_status = this.query.return_status;

        await orderApi.exportOrders(params);

        this.$swal({
          title: "成功",
          text: "可至「我的主控台」查看紀錄及下載檔案",
          showCancelButton: true,
          cancelButtonText: "確認",
          type: "success",
          confirmButtonText: "前往查看",
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "MyConsoleDownloadFileList",
              params: { org_code: this.$route.params.org_code },
            });
          }
        });
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "匯出失敗", "error");
      } finally {
        this.showLoading = false;
      }
    },
    // 根據模組設定解析會員欄位
    normalizeProfileFields() {
      // order.customer_list 是在 customer 模組的 module_config 內
      const customerList = this.getModuleConfig("customer", "order.customer_list");
      if (!customerList || customerList.length === 0) return [];

      let profileMappings = [];

      // 當 searchedMerchant 沒有 type（全部或尚未搜尋）時，使用第一筆設定
      if (!this.searchedMerchant?.type) {
        profileMappings = customerList[0]?.member_fields ?? [];
      } else {
        // 根據 merchant_type 匹配對應設定
        profileMappings = customerList.find(
          (list) => list.merchant_type?.toUpperCase() === this.searchedMerchant?.type?.toUpperCase()
        )?.member_fields ?? [];
      }

      return profileMappings.map((mapping) => {
        if (mapping.matched_key.startsWith("extra.")) {
          // extra.name -> customer.profiles.name
          const key = mapping.matched_key.split("extra.")[1];
          return {
            key: `customer.profiles.${key}`,
            label: mapping.title,
          };
        } else {
          // mobile_phone -> customer.mobile_phone
          return {
            key: `customer.${mapping.matched_key}`,
            label: mapping.title,
          };
        }
      });
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  opacity: 0.5;
}
</style>
